import { post } from 'App/Network/Axios';
import CsvToJson from 'App/Utils/Csv';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Button, FileInput, TOAST } from 'retro/index';

const UploadFile = ({
  setUploading,
  setShowStatusButton,
  setCsvData,
  csvData,
  setStatus,
  uploaded,
  setUploaded
}) => {
  const file = useRef();
  const [uploads, setUploads] = useState({});
  const { id, clientId } = useParams();

  const uploadCsv = (file) => {
    setUploading(true);
    CsvToJson(
      file,
      (rows) => {
        console.log('rows', rows);
        setCsvData(rows);
      },
      (row) => {
        if (row['Amount']) {
          return true;
        } else {
          setUploading(false);
        }
      }
    );
  };

  useEffect(() => {
    // When csvData changes, trigger the recursiveUpload function
    if (csvData.length > 0 && !uploaded) {
      recursiveUpload(csvData, 0);
    }
  }, [csvData]); // Add csvData as a dependency to this effect

  const upload = (csvData, cb) => {
    const { Amount: amount, Remarks: remarks } = csvData;

    let data = {
      amount: Number(amount),
      remarks: remarks.trim(),
    };

    post(`/accounts/account/${clientId}/${id}/add`, data, (e, r) => {
      if (r) {
        TOAST.success('Account recharged successfully');
        setStatus((prevState) => [
          ...prevState,

          {
            uploadStatus: 'Success',
            remarkMessage: 'Account recharged successfully',
          },
        ]);
        cb('Upload completed');
      } else {
        TOAST.error(e?.data?.message);
        setStatus((prevState) => [
          ...prevState,
          {
            uploadStatus: 'Failed',
            remarkMessage: e?.data?.message,
          },
        ]);
        cb(e.data.message);
      }
    });
  };

  const recursiveUpload = (csvData, i = 0, mState = {}) => {
    if (i >= csvData.length) {
      setUploaded(true);
      setUploading(false);
      setUploads({ ...mState });
      setShowStatusButton(true);
    } else {
      const row = csvData[i];
      upload(row, (message) => {
        const key = row['Amount']; // Assuming "Amount" is unique
        const state = { ...mState };
        state[key] = message;
        setUploads(state);
        recursiveUpload(csvData, i + 1, state);
      });
    }
  };

  return (
    <>
      <FileInput
        onSelect={uploadCsv}
        extensions={['.csv']}
        className="display-none"
        ref={file}
      />
      <Button
        onClick={() => {
          file.current.click();
          setShowStatusButton(false);
        }}
        className="btn btn-secondary text-small rounded-pill mr1"
      >
        <i className="fa fa-upload mr1" />
        Upload Csv
      </Button>
    </>
  );
};

export default UploadFile;
